<template>
  <div class="appointment-product-waiting-fulfill">
    <div class="load" v-if="isLoading"><div class="custom-loader"></div></div>
    <div class="search-box mb-5">
      <div @click="isActive = !isActive" class="button-toggle">
        <div class="search-title">ค้นหาช่วงสินค้า</div>
        <div class="arrow">
          <img :src="arrow" class="book-icon arrow" />
        </div>
      </div>
      <slide-up-down
        class="AccordionWrapper"
        :active="isActive"
        :use-hidden="true"
        :duration="500"
      >
        <appointment-filter-bar
          v-model="filterForm"
          @search="handleSearch"
          :isProductWaitingFulfillPage="true"
        ></appointment-filter-bar>
      </slide-up-down>
          <el-checkbox
            v-model="isOnlyTestUser"
            @change="handleSearch"
            ><p class="checkbox-font">
              ดูเฉพาะ User เทส
            </p>
          </el-checkbox>
    </div>
    <div class="product-list">
      <div class="paginate">
        <p>{{ totalCount }}</p>
        <div class="text-right">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="productLimit"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div
        class="histories"
        v-for="(history, i) in subscriptionHistoryProducts"
        :key="i"
      >
        <div class="history-box-row">
          <div class="text-center">
            <div class="status created">{{ history.statusText }}</div>
            <div style="font-size: 36px; line-height: 1.2">
              {{ history.dateText }}
            </div>
            <div style="font-size: 18px; line-height: 1.2">
              {{ history.monthText }}
            </div>
            <div style="font-size: 18px; line-height: 1.2">
              {{ history.yearText }}
            </div>
            <div style="font-size: 14px; line-height: 1.2">
              ({{ history.timeText }})
            </div>
          </div>
          <div class="services">
            <div
              class="service-appointment mb-1"
              v-for="(service, serviceIndex) in history.services"
              :key="serviceIndex"
            >
              <div class="subscription-service-detail">
                <div class="appointment-detail">
                  <router-link to="" class="title">{{
                    service.serviceName
                  }}</router-link>
                  <div v-if="service.mainOption" class="subtitle">
                    <label>option หลัก:</label>
                    {{ service.mainOption }}
                  </div>
                  <div v-if="service.extraOption" class="subtitle">
                    <label>option เสริม:</label>
                    {{ service.extraOption }}
                  </div>
                  <div class="subtitle">
                    <label>ผู้ให้บริการ:</label>
                    {{ service.providerName }}
                  </div>
                  <div class="subtitle">
                    <label>ลูกค้า:</label>
                    {{ history.user.name }} - {{ history.user.phoneNumber }}
                  </div>
                  <div class="subtitle">
                    <label>ที่อยู่:</label>
                    {{ history.home.addressNumber }} {{ history.home.project }}
                  </div>
                </div>
                <div class="btn-fulfill">
                  <sc-button
                    variant="success"
                    @click="
                      handleClickFulfillProductAsCustomerButton(
                        history,
                        service.serviceId
                      )
                    "
                    >เสร็จสิ้น</sc-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center p-4" v-if="!subscriptionHistoryProducts.length">
        ไม่มีข้อมูล
      </div>
      <div class="text-right mt-4">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="productLimit"
          :current-page="currentPage"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      class="custom-dialog"
      :title="dialog.title"
      :visible.sync="dialog.open"
      width="30%">
      <span>
        {{ dialog.message }}
      </span>
      <span 
        slot="footer" 
        class="dialog-footer">
        <el-button 
          @click="
            dialog.open = false
          ">
          ตกลง
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { toLocaleTH, convertDateTimeToTimeText } from "@/lib/dateTime";
import { DateTime } from "luxon";
import { Checkbox } from "element-ui";
import ScButton from "../../../../../lib/components/ScButton.vue";
import { Pagination } from "element-ui";
import SlideUpDown from "vue-slide-up-down";
import AppointmentFilterBar from "./AppointmentFilterBar.vue";
import {
  checkExistSomeValueInObject,
  existValueAndEmptyString
} from "../../../../../lib/util";

export default {
  name: 'AppointmentProductWaitingFulfill',
  components: {
    ScButton,
    "el-pagination": Pagination,
    "el-checkbox": Checkbox,
    "slide-up-down": SlideUpDown,
    AppointmentFilterBar,
  },
  data() {
    const filterForm = {
      purchasedAtRange: null,
      provider: null,
      project: null,
      service: null,
      home: null,
      status: null,
      user: null,
    };
    const isOnlyTestUser = false;

    return {
      dialog: {
        open: false,
        title: 'หัวข้อ',
        message: 'ข้อความ',
      },
      subscriptionHistoryProducts: [],
      total: 0,
      productLimit: 30,
      productPage: 1,
      isLoading: false,
      isActive: false,
      filterForm,
      isOnlyTestUser
    };
  },
  watch: {
    async "$route.query"(query, oldValue) {
      if (query.tab === oldValue.tab) {
        await this.setup();
      }
    },
    'dialog.open' (open) {
      // Reset Dialog
      if (!open) this.dialog = {
        open, title: '', message: '',
      }
    }
  },
  created() {
    const { isOnlyTestUser } = this.$route.query;
    this.isOnlyTestUser = isOnlyTestUser == "true";

    this.setup();
  },
  computed: {
    currentPage() {
      return parseInt(this.$route.query.productPage) || 1;
    },
    totalCount() {
      const productLimit = this.productLimit;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.subscriptionHistoryProducts.length;
      const isLastPage = productLimit > currentTotalItem;
      const end = (
        isLastPage ? total : this.currentPage * productLimit
      ).toLocaleString();
      const start = (
        (isLastPage
          ? productLimit * this.currentPage - productLimit
          : end - productLimit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    arrow() {
      return this.isActive
        ? "/static/icons/arrow-up-orange.svg"
        : "/static/icons/arrow-down-orange.svg";
    },
  },
  methods: {
    async setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const {
        purchasedFrom,
        purchasedTo,
        providerId,
        projectId,
        serviceId,
        homeId,
        userId,
        productPage,
      } = this.$route.query;

      this.productPage = (productPage && +productPage) || 1;
      this.filterForm = {
        provider: providerId ? { id: providerId } : null,
        project: projectId ? { projectId: projectId } : null,
        service: serviceId ? { id: serviceId } : null,
        home: homeId ? { homeId: homeId } : null,
        user: userId ? { user_id: +userId } : null,
        purchasedAtRange:
          purchasedFrom && purchasedTo
            ? {
                from: DateTime.fromISO(purchasedFrom),
                to: DateTime.fromISO(purchasedTo),
              }
            : null,
      };

      this.isActive = checkExistSomeValueInObject(this.filterForm);
    },
    async setupData() {
      const { count, appointment_product: appointmentProduct } =
        await this.fetchData();

      this.setDataHistoryAppointment(appointmentProduct);
      this.total = count;
    },
    async fetchData() {
      this.isLoading = true;

      const response =
        await baanRueJaiClient.admin.subscriptions.appointments.getAppointmentProductWaitingConfirm(
          { ...this.$route.query, page: this.$route.query.productPage || 1 }
        );

      this.isLoading = false;

      return response.data.result;
    },
    async handleClickFulfillProductAsCustomerButton(history, serviceSelectId) {
      const now = DateTime.utc().toISO();

      const serviceSelect = history.services.find(
        (service) => service.serviceId === serviceSelectId
      );

      if (!serviceSelect) {
        alert("ไม่สามารถบันทึก เสร็จสิ้นได้");
        return;
      }

      try {

        // Loading
        this.isLoading = true;

        // Request Payload
        const paramsForm = {
          dateTime: now,
          serviceId: serviceSelect.serviceId.toString(),
          providerId: serviceSelect.providerId.toString(),
          homeId: history.home.homeId.toString(),
          projectId: history.home.projectId.toString(),
          userId: history.user.id.toString(),
          subscriptionId: history.subscriptionId,
          dateTimeEnd: undefined,
          isFulfillAppointment: true,
        };

        // Request Create Appointment
        await baanRueJaiClient.admin.subscriptions.appointments.postCreate(
          paramsForm
        );

        // Mapping Product
        const subscriptionHistoryProducts =
          this.subscriptionHistoryProducts.map((historyProduct) => {
            const services =
              historyProduct.historyId === history.historyId
                ? historyProduct.services.filter(
                    (service) => service.serviceId !== serviceSelectId
                  )
                : historyProduct.services;

            return {
              ...historyProduct,
              services,
            };
          });

        // Mapping Product History
        this.subscriptionHistoryProducts = subscriptionHistoryProducts.filter(
          (historyProduct) =>
            historyProduct.services && historyProduct.services.length > 0
        );

        // Emit Reload Event
        this.$emit("reloadAppointmentDashboardPage");

        // Success Alert
        this.dialog.title = 'สำเร็จ'
        this.dialog.message = 'บันทึกข้อมูลเรียบร้อย'
      }
      catch (error) {

        // Error Alert
        this.dialog.title = 'ล้มเหลว'
        this.dialog.message = 'บันทึกข้อมูลผิดพลาด กรุณาติดต่อเจ้าหน้าที่'
      }
      finally {
        
        // Loaded
        this.isLoading = false;

        // Alert Information
        this.dialog.open = true
      }
    },
    setDataHistoryAppointment(appointmentProduct) {
      const histories = appointmentProduct.map((history) => {
        const services = history.subscription.services.map((service) => {
          const optionService = existValueAndEmptyString(history.subscription.items) &&
            history.subscription.items.length > 0 &&
            history.subscription.items[0].services &&
            history.subscription.items[0].services.length > 0
              ? history.subscription.items[0].services.find(
                  (ser) => ser.service_id === service.id
                )
              : null;

          const mainOption = optionService &&
            existValueAndEmptyString(optionService.main_option) &&
            optionService.main_option.title
              ? optionService.main_option.title
              : null;

          const extraOption = optionService &&
            existValueAndEmptyString(optionService.extra_option) &&
            optionService.extra_option.length > 1
              ? optionService.extra_option
                  .map((extra) => extra.title)
                  .join(", ")
              : null;

          return {
            serviceId: service.id,
            serviceName: service.name,
            providerName: service.provider.name,
            providerId: service.provider.id,
            mainOption,
            extraOption
          };
        });

        const purchasedAt = toLocaleTH(DateTime.fromISO(history.created_at));
        const dateText = purchasedAt.day;
        const monthText = purchasedAt.toFormat("MMM");
        const yearText = purchasedAt.toFormat("yyyy");
        const timeText = convertDateTimeToTimeText(purchasedAt, "HH:mm น.");

        const user = {
          id: history.subscription.owner.user_id,
          name: `${history.subscription.owner.first_name} ${history.subscription.owner.last_name}`,
          phoneNumber: history.subscription.owner.mobile_number,
        };

        const home = history.subscription.home
          ? {
              homeId: history.subscription.home_id,
              addressNumber: history.subscription.home.address_no,
              project: history.subscription.home.project
                ? `${history.subscription.home.project.project_code} โครงการ${history.subscription.home.project.project_name}`
                : "-",
              projectId:
                history.subscription.home.project &&
                history.subscription.home.project.project_id,
            }
          : {
              homeId: "",
              addressNumber: "-",
              project: "-",
            };

        return {
          historyId: history.id,
          services,
          user,
          home,
          statusText: "ซื้อใหม่",
          dateText,
          monthText,
          yearText,
          timeText,
          subscriptionId: history.subscription.id,
        };
      });

      this.subscriptionHistoryProducts = histories;
    },
    handleCurrentChange(productPage) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, productPage, page: 1 },
      };

      this.$router.replace(route);
    },
    async handleSearch() {
      const query = {};

      const {
        purchasedAtRange,
        provider,
        project,
        service,
        home,
        user,
      } = this.filterForm;

      if (purchasedAtRange) {
        query.purchasedFrom = purchasedAtRange.from.toISO();
        query.purchasedTo = purchasedAtRange.to.toISO();
      } else {
        query.purchasedFrom = null;
        query.purchasedTo = null;
      }

      query.isOnlyTestUser = this.isOnlyTestUser || false;

      query.homeId = home && home.homeId || null;

      query.projectId = project && project.projectId || null;

      query.providerId = provider && provider.id || null;

      query.serviceId = service && service.id || null;

      query.userId = user && user.user_id || null;

      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, ...query, page: 1, productPage: 1 },
      };

      this.$router.replace(route);
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/lib/scss/variables";

.appointment-product-waiting-fulfill {
  position: relative;
}

.history-box-row {
  display: grid;
  grid-template-columns: 110px auto;
  grid-gap: $space / 2;
  align-items: center;
  border-bottom: 1px solid #cecece;

  & + & {
    margin-top: $space;
  }

  padding-top: 15px;
  padding-bottom: 15px;
  padding-right: 20px;
}

.status {
  line-height: 1.2;
  font-weight: bold;
  text-align: center;

  &.created {
    color: $secondary-color;
  }
}

.title,
.subtitle {
  line-height: 1.6;
}

.title {
  font-size: 1rem;
}

.subtitle {
  font-size: 1rem;
}

.subscription-service-detail {
  display: flex;
  justify-content: space-between;
  padding: 15px;
  border: 1px solid #ebebea;
  border-radius: 5px;
}

p {
  display: inline;
}

label {
  display: inline;
  font-size: 0.8rem;
  color: #606060;
}

.paginate {
  display: flex;
  justify-content: space-between;
}

.load {
  display: flex;
  justify-content: center;
}

.custom-loader {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: conic-gradient(#0000 10%, #e27024) content-box;
  -webkit-mask: repeating-conic-gradient(
      #0000 0deg,
      #000 1deg 20deg,
      #0000 21deg 36deg
    ),
    radial-gradient(
      farthest-side,
      #0000 calc(100% - 9px),
      #000 calc(100% - 8px)
    );
  -webkit-mask-composite: destination-in;
  mask-composite: intersect;
  animation: s4 1s infinite steps(10);
  position: fixed;
  z-index: 9999999;
}

@keyframes s4 {
  to {
    transform: rotate(1turn);
  }
}

.button-toggle {
  width: 100%;
  height: 59px;
  background-color: rgb(240, 240, 240);
  border-radius: 0;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  text-align: left;
  padding: 8px 30px;
  display: flex;
  justify-content: space-between;
}

.book-icon {
  padding-right: 15px;
}

.search-icon {
  width: 38px;
  margin-bottom: 7px;
}

.search-title {
  font-size: 24px;
  line-height: 35px;
  font-weight: bold;
  color: #000;
}

.arrow {
  text-align: right;
}
</style>

<style scoped>
.custom-dialog >>> .el-dialog__header {
  font-weight: bold;  
}

.custom-dialog >>> .el-dialog__body {
  padding: 1rem 20px;
}
</style>


// WEBPACK FOOTER //
// src/features/subscriptions/modules/appointments/components/AppointmentProductWaitingFulfill.vue